import { PatchOptimizationWorkloadRequest } from '@cast/types';

const generateFieldPaths = (
  obj: any,
  basePath: string,
  paths: string[]
): void => {
  if (obj === null || obj === undefined) {
    return;
  }

  if (typeof obj !== 'object' || Array.isArray(obj)) {
    if (obj !== undefined && obj !== null) {
      paths.push(basePath);
    }
    return;
  }

  for (const [key, value] of Object.entries(obj)) {
    const currentPath = basePath ? `${basePath}.${key}` : key;

    // Include undefined values in update mask to explicitly clear fields
    // undefined values tell the API to remove or reset the field value
    if (value === undefined) {
      paths.push(currentPath);
      continue;
    }

    // Include null values in update mask to explicitly clear fields
    // Null values tell the API to remove or reset the field value
    if (value === null) {
      paths.push(currentPath);
      continue;
    }

    // Include primitive values and arrays in update mask
    // These represent concrete values that should be updated on the server
    if (typeof value !== 'object' || Array.isArray(value)) {
      paths.push(currentPath);
      continue;
    }

    generateFieldPaths(value, currentPath, paths);
  }
};

/**
 * Builds an updateMask string for PATCH requests based on the fields present in the workload request.
 * The updateMask follows the format: field1,field2,field3
 *
 * This function automatically detects all defined fields in the workload.workload object
 *
 * @param workload - The workload update request containing the fields to be updated
 * @returns A comma-separated string of field paths for the updateMask
 */
export const buildUpdateMask = (
  workload?: PatchOptimizationWorkloadRequest['workload']
): string => {
  const paths: string[] = [];

  if (workload) {
    generateFieldPaths(workload, 'workload', paths);
  }

  return paths.join(',');
};
